module.exports = __webpack_public_path__ + "static/media/myNiuWsScreen.6349214a.png";